import { useEffect } from 'react';
import { syncEngine } from '../sync/engine';
import type { Id } from '../../lib/types';
import { useDeviceStore } from '../../store/device';

// Each kid-facing page calls this so the persistent quick-switcher button
// shows the right avatar (plan/03 §B). No-op when profileId is missing —
// useParams may briefly resolve to undefined during render.
//
// Also re-targets the sync engine's progress subscription. Without this,
// the engine reads activeProfileId once at start and never updates, so a
// device that joined sync before any profile was active never subscribes
// to the right `progress` filter and remote task taps never push live.
// `onActiveProfileChanged` is a no-op when the engine isn't running, so
// firing it on devices without a sync code is harmless.
export function useActiveProfile(profileId: Id | undefined): void {
  const setActiveProfileId = useDeviceStore((s) => s.setActiveProfileId);

  useEffect(() => {
    if (!profileId) return;
    setActiveProfileId(profileId);
    syncEngine.onActiveProfileChanged(profileId);
  }, [profileId, setActiveProfileId]);
}
